import useAlias from '@alias';
import Button from '@components/_elements/Button/Button';
import Input from '@components/_elements/Input/Input';
import { selectFormStyles } from '@components/Home/Historian/SavedSearchRow/SelectForm';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Actions } from '@src/types/Actions';
import storeConnector from '@store/storeConnector';
import { SavedSearch } from '@types';
import React, { ReactElement } from 'react';

interface EditFormProps {
  searchOptions: string[];
  activeSearch: SavedSearch;
  searchUnderEdit: SavedSearch;
  setSearchUnderEdit: React.Dispatch<SavedSearch | null>;
  setSearchField: (field: string, value: string) => void;
  setActiveSearch: React.Dispatch<SavedSearch>;
  actions: Actions;
}
function EditForm(props: EditFormProps): ReactElement {
  const alias = useAlias();
  const {
    actions,
    searchOptions,
    activeSearch,
    searchUnderEdit,
    setSearchUnderEdit,
    setSearchField,
    setActiveSearch,
  } = props;
  let error = '';
  if (
    searchOptions.includes(activeSearch.name) &&
    activeSearch.name !== searchUnderEdit.name
  ) {
    error = alias('This name is already in use');
  }
  if (!activeSearch.name) {
    error = alias('Search name cannot be empty');
  }
  // todo: clean up this logic
  const disabled =
    !activeSearch.name ||
    (searchOptions.includes(activeSearch.name) &&
      activeSearch.name !== searchUnderEdit.name);

  const saveEditedSearch = async () => {
    setActiveSearch(await actions.saveEditedHistorianSearch(activeSearch));
  };

  return (
    <div style={selectFormStyles}>
      <div className='input-search-name'>
        <Input
          error={error}
          type='text'
          value={activeSearch.name}
          onChange={(val: string): void => setSearchField('name', val)}
          placeholder={alias('New search name')}
        />
      </div>
      <Button
        title={alias('Cancel')}
        classType='container-bg'
        size='s'
        style={{ marginLeft: 10 }}
        onClick={(): void => {
          setActiveSearch(searchUnderEdit);
          setSearchUnderEdit(null);
        }}
      >
        <FontAwesomeIcon icon={faTimes} />
      </Button>
      <Button
        title={alias('Save')}
        classType='container-bg'
        size='s'
        style={{ marginLeft: 10 }}
        disabled={disabled}
        onClick={saveEditedSearch}
      >
        <FontAwesomeIcon icon={faCheck} />
      </Button>
    </div>
  );
}

export default storeConnector(EditForm, {});
